import { gql } from '@apollo/client';

export const UPDATE_USER_MUTATOR = gql`
  mutation updateUserMutator($user_id: String, $updated_user: JSON, $user_email: String) {
    updateUser(user_id: $user_id, updated_user: $updated_user, user_email: $user_email)
  }
`;

export const RESTORE_USER_MUTATOR = gql`
  mutation restoreUserMutator($user_id: String, $user_email: String) {
    restoreUser(user_id: $user_id, user_email: $user_email)
  }
`;

export const ADD_USER_MUTATOR = gql`
  mutation addUserMutator($user: JSON) {
    addUser(user: $user)
  }
`;
